import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { CommonFunctions } from '@shared/common-functions';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-success-failed-modal',
  templateUrl: './success-failed-modal.component.html',
  styleUrls: ['./success-failed-modal.component.scss']
})
export class SuccessFailedModalComponent implements OnInit {
  bodyText = '';
  headerText = '';
  svgType = 0;
  buttonText: string;
  role : string = '';
  roleRoute : string = '';

  constructor(private readonly router: Router, public readonly ref: DynamicDialogRef, public readonly config: DynamicDialogConfig, private readonly encryptStorage: EncryptionStorageService) { }

  ngOnInit(): void {
    this.bodyText = this.config.data.bodyText;
    this.headerText = this.config?.data?.headerText;
    this.svgType = this.config?.data?.svgType;
    this.buttonText = this.config?.data?.buttonText;
    this.role = this.encryptStorage.getItem('roleName');
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  continue(): void {
    this.ref.close();
    this.router.navigate([`${this.roleRoute}/custom-credit-list`]);
    
  }
}
